export default "__VITE_ASSET__qg9pPhA___"